export default __webpack_public_path__ + "static/media/hendrix.0b54eb91.webp";